export default __webpack_public_path__ + "static/media/hombre.fad1abd7.svg";